@if (text) {
<span class="sort-text" [atxTooltip]="tooltip" [tooltipEnabled]="tooltip">{{
  text
}}</span>
}
<ng-content></ng-content>
<div class="arrows-container">
  <fa-icon
    class="sort-arrow"
    [class.active]="
      currentSort?.type === action?.value &&
      currentSort?.direction.toLowerCase() === ascDirection
    "
    [icon]="['fas', 'chevron-up']"
    size="xs"
  ></fa-icon>
  <fa-icon
    class="sort-arrow"
    [class.active]="
      currentSort?.type === action?.value &&
      currentSort?.direction.toLowerCase() === descDirection
    "
    [icon]="['fas', 'chevron-down']"
    size="xs"
  ></fa-icon>
</div>
